import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";

import {useMaterialUIController} from "../../../context";
import MDButton from "../../../components/MDButton";
import {useNavigate} from "react-router-dom";

function StatisticsCard({ title, count, percentage, dropdown, range, reportBaseUrl, disabled }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const navigate = useNavigate();

  return (
    <Card style={{
      background:disabled ? '#f4f0df' : "#fff"
    }}>
      <MDBox p={2}>
        <Grid container>
          <Grid item xs={12}>
            <MDBox mb={0.5} lineHeight={1}>
              <MDTypography
                variant="button"
                fontWeight="medium"
                color="text"
                textTransform="capitalize"
              >
                {title}

                {range && <MDButton
                  color="primary"
                  size="small"
                  className="pull-right"
                  onClick={()=>{
                    navigate('/' + reportBaseUrl + '/report/' + range)
                  }}
                  >View All
                </MDButton> }

              </MDTypography>
            </MDBox>
            <MDBox lineHeight={1}>
              <h5 fontWeight="bold">
                {range && <><a href={'/' + reportBaseUrl + '/report/' + range}>{count}</a></>}
                {!range && <>{count}</>}
              </h5>
              <MDTypography variant="button" fontWeight="bold" color={percentage.color}>
                {percentage.value}
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color={darkMode ? "text" : "secondary"}
                >
                  {percentage.label}
                </MDTypography>
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={5}>
            {dropdown && (
              <MDBox width="100%" textAlign="right" lineHeight={1}>
                <MDTypography
                  variant="caption"
                  color="secondary"
                  fontWeight="regular"
                  sx={{ cursor: "pointer" }}
                  onClick={dropdown.action}
                >
                  {dropdown.value}
                </MDTypography>
                {dropdown.menu}
              </MDBox>
            )}
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

// Typechecking props for the DefaultStatisticsCard
StatisticsCard.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  dropdown: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      action: PropTypes.func,
      menu: PropTypes.node,
      value: PropTypes.string,
    }),
  ]),
};

export default StatisticsCard;
